@let j = journey();
<section class="aj-card" aria-label="Answer journey">
  <div class="flex flex-wrap items-center justify-between gap-2">
    <h4 class="aj-heading">Answer journey</h4>
    <span class="aj-badge">NEW · from tracked events</span>
  </div>

  <div class="aj-stats">
    @for (stat of j.stats; track stat.label) {
    <div class="aj-stat">
      <p class="aj-stat-label">{{ stat.label }}</p>
      <p class="aj-stat-value" [attr.data-tone]="stat.valueTone ?? null" [title]="stat.value">{{ stat.value }}</p>
      @if (stat.hint) {
      <p class="aj-stat-hint" [attr.data-tone]="stat.hintTone ?? null">{{ stat.hint }}</p>
      }
    </div>
    }
  </div>

  @if (j.events.length) {
  <ol class="aj-timeline">
    @for (event of j.events; track $index) {
    <li class="aj-event">
      <span class="aj-time">{{ event.time }}</span>
      <span class="aj-dot" [attr.data-tone]="event.tone" aria-hidden="true"></span>
      <div class="min-w-0">
        <p class="aj-event-title" [attr.data-tone]="event.tone">{{ event.title }}</p>
        @if (event.detail) {
        <p class="aj-event-detail">{{ event.detail }}</p>
        }
      </div>
    </li>
    }
  </ol>
  } @else {
  <p class="mt-4 text-sm text-text-secondary">No tracked events for this question.</p>
  }

  <p class="aj-takeaway" [attr.data-tone]="j.takeawayTone">
    <span class="font-semibold text-[#111827]">Takeaway:</span> {{ j.takeaway }}
  </p>

  @if (j.isIncomplete) {
  <p class="mt-2 text-xs text-text-secondary">
    Some activity on this question wasn't captured, so this journey may be incomplete.
  </p>
  }
</section>